import { useState, useEffect } from "react";
import { useSnackbar } from "notistack";
import { useAgendaCareContext } from "../../../../../Context/AgendaCareContext";
import { api } from "../../../../../services/Api";
import getApiErrorMessage from "../../../../../utils/getApiErrorMessage";
import { validarPeriodoAgenda } from "../../../utils/validarPeriodoAgenda";

function montarParamsBusca({
  situacao,
  hora,
  enfermeiroId,
  cliente,
  dataInicial,
  dataFinal,
}) {
  const params = {
    dataInicial,
    dataFinal,
  };

  if (situacao) params.situacao = situacao;
  if (hora) params.hora = hora;
  if (enfermeiroId) params.enfermeiroId = enfermeiroId;
  if (cliente?.id != null && cliente.id !== "") params.clienteId = cliente.id;

  return params;
}

export default function useTabelaAgendamentos() {
  const { enqueueSnackbar } = useSnackbar();
  const {
    situacao,
    setSituacao,
    hora,
    setHora,
    enfermeiroId,
    setEnfermeiroId,
    cliente,
    setCliente,
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal,
  } = useAgendaCareContext();

  const [atualizar, setAtualizar] = useState(false);
  const [rows, setRows] = useState([]);

  const atualizarTabela = () => {
    setAtualizar(!atualizar);
  };

  const dadosAgendamentos = async () => {
    const erroPeriodo = validarPeriodoAgenda(dataInicial, dataFinal);

    if (erroPeriodo) {
      setRows([]);
      enqueueSnackbar(erroPeriodo, { variant: "warning", preventDuplicate: true });
      return;
    }

    try {
      const response = await api.get("/v2/agendaCare/agendamentos", {
        params: montarParamsBusca({
          situacao,
          hora,
          enfermeiroId,
          cliente,
          dataInicial,
          dataFinal,
        }),
      });
      setRows(response.data.data);
    } catch (error) {
      setRows([]);
      enqueueSnackbar(
        getApiErrorMessage(error, "Não foi possível encontrar os agendamentos."),
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    dadosAgendamentos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    situacao,
    hora,
    enfermeiroId,
    cliente?.id,
    dataInicial,
    dataFinal,
    atualizar,
  ]);

  return {
    atualizarTabela,
    rows,
    situacao,
    setSituacao,
    hora,
    setHora,
    enfermeiroId,
    setEnfermeiroId,
    cliente,
    setCliente,
    dataInicial,
    setDataInicial,
    dataFinal,
    setDataFinal,
  };
}
